import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div className='container my-5'>
            <div className='theme-bg mx-md-5'>
                <div className="row p-5 d-flex align-items-center justify-content-center">
                    <div className="col-md-4">
                        <h1>Have an idea?</h1>
                        <h1 className="fw-bold">Let's Get In <br /> Touch Now?</h1>
                    </div>
                    <div className="col-md-8 card p-5 border-0">
                        <form className="row contact-form">
                            <div className="col-md-6 cl-12">
                                <label for="inputName" className="form-label">First Name</label>
                                <input type="text" className="form-control" placeholder='Robert lee' />
                            </div>
                            <div className="col-md-6 col-12">
                                <label for="inputName" className="form-label">Last Name</label>
                                <input type="text" className="form-control" placeholder='Anderson' />
                            </div>
                            <div className="col-md-6 col-12">
                                <label for="inputEmail" className="form-label">Your Email Address</label>
                                <input type="text" className="form-control" placeholder="kevin.jones@mail.com" />
                            </div>
                            <div className="col-md-12">
                                <label for="inputState" className="form-label">Services</label>
                                <select id="inputState" className="form-select">
                                    <option selected>Select Service Type</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="exampleFormControlTextarea1" className="form-label">Type Your Message</label>
                                <textarea class="form-control" placeholder='Write a brief' rows="3"></textarea>
                            </div>

                            <div className="text-center mt-3">
                                <button type="submit" className="btn btn-dark px-3 py-2">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;